export default "/assets/images/app-screen2.b9bc376bd22d9c72.webp";